// engine
import { ArContainer, ArSprite } from '@aceroll/core';

export class StudioLogo extends ArContainer {
	#logo;

	constructor() {
		super('logo-studio');
		this.#logo = ArSprite.from('preloader-studio_logo');
		this.#logo.anchor.set(0.5);
		this.#logo.position.set(0, 0);

		this.addChild(this.#logo);
	}
}
